import React from 'react'

const FooterColumnTitle = ({ text, href, target = '_self' }) => (
  <h4 className="mb-2.5 font-semibold text-white">
    {href ? (
      <a
        className="text-white no-underline md:hover:underline"
        href={href}
        target={target}
      >
        {text}
      </a>
    ) : (
      text
    )}
  </h4>
)

export default FooterColumnTitle
